import {
    REQUEST_REVIEW_LIST,
    REQUEST_REVIEW_LIST_FOR_CAMPAIGN
} from './mutation-types';

export default {
    [REQUEST_REVIEW_LIST] (state, receivedData) {
        state.reviews = receivedData.content;
        state.reviewCount = receivedData.totalElements;
    },
    [REQUEST_REVIEW_LIST_FOR_CAMPAIGN] (state, receivedData) {
        state.reviews = receivedData.content;
        state.reviewCount = receivedData.totalElements;
    }
}